import React, { useEffect } from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ProviderMatchProviderV9, PMCConfig } from '@kyruus/types';

import {
  CardContentContainer,
  CardContentHeader,
  ProviderInformationCard,
  CardContentText
} from './styles';
import { isSummaryDataConfigured } from '../../lib/utils';
import messages from '../../lib/messages';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

const Gender = ({
  provider,
  config,
  shouldSkipRender,
  intl
}: {
  provider: ProviderMatchProviderV9;
  config: PMCConfig;
  shouldSkipRender: (component: string) => void;
} & WrappedComponentProps): React.ReactElement | null => {
  const isGenderValueIgnored = (config.provider_v9?.summary_data || []).find(
    (s) =>
      s.field === 'gender' &&
      Array.isArray(s.ignore) &&
      s.ignore.includes(provider.gender)
  );

  const skipRendering =
    !isSummaryDataConfigured('gender', config) ||
    !provider.gender ||
    isGenderValueIgnored;

  useEffect(() => {
    if (skipRendering) {
      // callback to the parent component to skip rendering
      shouldSkipRender('gender');
    }
  }, [skipRendering]);

  // do not render if summary_data field not present
  // or data is not present
  // gender is falsy or icon is not found
  if (skipRendering) {
    return null;
  }

  return (
    <ProviderInformationCard>
      <CardContentContainer>
        <CardContentHeader>
          {intl.formatMessage(messages.genderHeader)}
        </CardContentHeader>
        <CardContentText>{provider.gender}</CardContentText>
      </CardContentContainer>
    </ProviderInformationCard>
  );
};

export default withErrorBoundary(injectIntl(Gender));
